/* MS (Oct 21): long-scroll memory + resume for infinite-scroll collection grids (e.g. BAOBAB, 800+ products).
   1) DOM windowing: only cards within ~6000px of the viewport keep real markup; the rest become empty
      fixed-height <li> shells (rebuilt from their saved HTML on approach), so DOM + images stay flat on iOS.
   2) URL ?page= follows the page actually on screen (replaceState) and the exact card + offset is kept in
      sessionStorage, so reload / back from a product / Safari's crash-reload resumes where the shopper was. */
(function () {
  if (window.__msCollMem) return;
  window.__msCollMem = true;
  var BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  var KEY = 'ms-coll-pos:' + location.pathname;
  var root = document.querySelector('results-list') || document;
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  // ---- DOM windowing: cards far from the viewport are emptied to a fixed-height shell ----
  // Each <li> card keeps its id/data-page (so infinite scroll, ?page tracking and resume keep working),
  // but its contents (product-card, swipe gallery, quick-add, badges, images) are detached and kept only
  // as an HTML string. Images get a blank src and lose srcset first so iOS frees the decoded bitmaps.
  // Hysteresis (empty beyond ~4500px, rebuild within ~2500px) stops cards flapping/re-rendering.
  // Perf (Oct 21 pm): no forced layout anywhere in here — heights come from the IntersectionObserver entry,
  // DOM writes are batched in one rAF, and scroll-time work only touches the handful of on-screen cards.
  var html = new WeakMap();
  var pending = new Map(); // card -> {act:'empty'|'rebuild', h}
  var raf = 0;
  function flush() {
    raf = 0;
    pending.forEach(function (job, card) {
      if (job.act === 'empty') {
        if (card.__msOff || !html.has(card) || job.h < 20) return;
        card.__msOff = 1;
        card.style.height = job.h + 'px';
        var ims = card.getElementsByTagName('img');
        for (var i = 0; i < ims.length; i++) { ims[i].removeAttribute('srcset'); ims[i].setAttribute('src', BLANK); }
        card.textContent = '';
        card.setAttribute('data-ms-shell', '');
      } else {
        if (card.__msOff) {
          card.__msOff = 0;
          card.innerHTML = html.get(card); // same URLs as before -> served from HTTP cache
          card.removeAttribute('data-ms-shell');
          card.style.height = '';
        }
        // start the main photo now (~3 screens ahead) instead of waiting for Safari's late lazy-load
        var im = card.querySelector('slideshow-slide img, .card-gallery img');
        if (im && im.loading === 'lazy' && im.getAttribute('src')) im.loading = 'eager';
      }
    });
    pending.clear();
  }
  function queue(card, job) { pending.set(card, job); if (!raf) raf = requestAnimationFrame(flush); }
  var nearIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) queue(e.target, { act: 'rebuild' }); });
  }, { rootMargin: '3000px 0px 3000px 0px' });
  var farIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting) queue(e.target, { act: 'empty', h: e.boundingClientRect.height }); });
  }, { rootMargin: '6000px 0px 6000px 0px' });
  var onScreen = new Set();
  var visIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) onScreen.add(e.target); else onScreen.delete(e.target); });
  });
  var seen = new WeakSet();
  function watch() {
    var list = root.querySelectorAll('[ref="grid"] > [ref="cards[]"]');
    for (var i = 0; i < list.length; i++) {
      var c = list[i];
      if (seen.has(c)) continue;
      seen.add(c);
      html.set(c, c.innerHTML); // pristine server markup, captured before any hydration
      nearIO.observe(c); farIO.observe(c); visIO.observe(c);
    }
  }
  // only react to cards being added to the grid (not to a card rebuilding its own contents)
  var mo = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (!m.addedNodes.length) continue;
      if (m.target.closest && m.target.closest('[ref="cards[]"]')) continue;
      watch(); return;
    }
  });
  mo.observe(root === document ? document.body : root, { childList: true, subtree: true });
  watch();

  // ---- position memory ----
  var cards = function () { return root.querySelectorAll('[ref="cards[]"]'); };
  function topCard() {
    var best = null, bt = Infinity;
    onScreen.forEach(function (c) {
      var r = c.getBoundingClientRect();
      if (r.bottom > 80 && r.top < bt) { bt = r.top; best = c; }
    });
    return best;
  }
  var t = 0;
  var ready = false; // don't overwrite the saved spot until we've restored it
  function save() {
    t = 0;
    if (!ready) return;
    var c = topCard();
    if (!c || !c.dataset.page) return;
    var page = c.dataset.page;
    try { sessionStorage.setItem(KEY, JSON.stringify({ id: c.id, page: page, off: Math.round(c.getBoundingClientRect().top) })); } catch (e) {}
    var u = new URL(location.href);
    if (page === '1') u.searchParams.delete('page'); else u.searchParams.set('page', page);
    if (u.href !== location.href) history.replaceState(history.state, '', u.toString());
  }
  window.addEventListener('scroll', function () { if (!t) t = setTimeout(save, 250); }, { passive: true });
  window.addEventListener('pagehide', save);

  function restore() {
    var s;
    try { s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    var urlPage = new URL(location.href).searchParams.get('page') || '1';
    // only resume when we landed on the page we left (a fresh visit to page 1 starts at the top)
    if (!s || !s.id || (String(s.page) !== urlPage && !document.getElementById(s.id))) { ready = true; return; }
    var tries = 0, hits = 0;
    (function go() {
      var el = document.getElementById(s.id);
      if (el) {
        window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - (s.off || 0), behavior: 'instant' });
        hits++;
      }
      // re-align a few times: the previous page may get prepended above us right after load
      if (++tries < 12 && hits < 4) setTimeout(go, 250); else ready = true;
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore); else restore();
  window.addEventListener('pageshow', function (e) { if (e.persisted) restore(); });
})();
